import styled from 'styled-components'

export const FormWrapper = styled.div`
  margin-bottom: 0.5rem;
  max-width: 30rem;
`
